import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

export const Overlay = styled.div`
  position: absolute;
  z-index: 2;
  width: 100%;
  height: 100%;

  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;

  background-color: ${themeGet('colors.cream')};
  background-image: ${({ image }) => `url(${image})`};
  background-repeat: no-repeat;
  background-size: cover;
  /* background-position: top center; */
  background-position: ${({ bgPosition }) => bgPosition};

  &.video-with-cta-overlay {
    max-height: 480px;
  }
`;
